import type { ButtonHTMLAttributes } from 'react'
import { Button } from '~/components/button'

type SnackbarActionButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  closable?: boolean
  onClickAction?: () => void
}

export const SnackbarActionButton = (props: SnackbarActionButtonProps) => {
  const { closable, onClickAction } = props
  return (
    <Button.Root
      variant="neutral-tertiary"
      onClick={onClickAction}
      data-testid="snackbar-action-button"
      size="ml"
    >
      <Button.Icon
        symbol={closable ? 'rdicon-dismiss' : 'rdicon-chevron-right'}
      />
    </Button.Root>
  )
}
